// src/features/admin-panel/_vm/use-events.ts
import { useCallback } from "react";
import {
  fetchClient,
  publicRqClient,
  rqClient,
} from "../../shared/api/instance";
// import { ApiSchemas } from "../shared/api/schema";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { queryClient } from "../../shared/api/query-client";
import { useMutation } from "@tanstack/react-query";
import { keepPreviousData } from "@tanstack/react-query";
import { PAGE_SIZE } from "../../constants";

export function useGetEvents({
  size = PAGE_SIZE,
  sort,
  status,
  tier,
  region,
  city,
}) {
  const { fetchNextPage, data, isFetchingNextPage, isPending, hasNextPage } =
    rqClient.useInfiniteQuery(
      "get",
      "/events/v1/events",
      {
        params: {
          query: {
            ...(status && status.length > 0
              ? { status: status.join(",") }
              : {}),
            ...(tier && tier.length > 0 ? { tier: tier.join(",") } : {}),
            ...(region ? { region } : {}),
            ...(city ? { city } : {}),
            page: 0,
            size,
            sort: sort ? [sort] : undefined,
          },
        },
      },
      {
        initialPageParam: 0,
        pageParamName: "page",
        getNextPageParam: (lastPage, _, lastPageParams) =>
          lastPage.data?.totalPages &&
          Number(lastPageParams) < lastPage.data.totalPages - 1
            ? Number(lastPageParams) + 1
            : undefined,
        placeholderData: keepPreviousData,
      }
    );

  const cursorRef = useCallback(
    (el) => {
      const observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && hasNextPage && !isFetchingNextPage) {
            fetchNextPage();
          }
        },
        { threshold: 0.1 }
      );

      if (el) {
        observer.observe(el);
        return () => {
          observer.disconnect();
        };
      }
    },
    [fetchNextPage, hasNextPage, isFetchingNextPage]
  );

  return {
    events:
      data?.pages.flatMap(
        (page) =>
          page.data?.content?.filter(
            (event, index, self) =>
              self.findIndex((e) => e.id === event.id) === index
          ) || []
      ) || [],
    fetchNextPage,
    isFetchingNextPage,
    isPending,
    hasNextPage,
    cursorRef,
    currentPage: data?.pages.length ? data.pages.length - 1 : 0,
    totalPages: data?.pages[0]?.data?.totalPages || 0,
  };
}

export function useGetSeriesById(id, customerId) {
  return useQuery(
    rqClient.queryOptions(
      "get",
      "/events/v1/series/{id}",
      {
        params: {
          path: { id },
          query: { customerId },
        },
      },
      {
        enabled: !!customerId,
      }
    )
  );
}

// Хук для инвалидации
export function useInvalidateSeries() {
  return ({ user, region, city, sort }) => {
    queryClient.invalidateQueries({
      queryKey: rqClient.queryOptions("get", "/events/v1/series", {
        params: {
          query: {
            region, // или другой дефолтный ID, если нужно
            city,
            sort: sort || "start,desc",
          },
        },
      }).queryKey,
    });
  };
}

export function useGetSeries({ user, region, city, sort }) {
  console.log("useGetSeries", user, region, city, sort);
  return rqClient.useQuery(
    "get",
    "/events/v1/series",
    {
      params: {
        query: {
          region, // или другой дефолтный ID, если нужно
          city,
          sort: sort || "start,desc",
        },
      },
    },
    {
      enabled: !!user,
    }
  );
}

export function useGetSeriesPublic({ user, region, city, sort }) {
  return publicRqClient.useQuery(
    "get",
    "/events/v1/series",
    {
      params: {
        query: {
          region, // или другой дефолтный ID, если нужно
          city,
          sort: sort || "start,desc",
        },
      },
    },
    {
      // enabled: !user,
    }
  );
}

export function useGetEventSeries({ region, city, sort }) {
  const { data, isLoading } = useQuery({
    queryKey: ["event-series", region, city],
    queryFn: async ({ pageParam = 0 }) => {
      console.log("useGetEventSeries", region, city);
      const res = await fetchClient.GET("/events/v1/series", {
        params: {
          query: {
            region,
            city,
            sort: ["start,asc"],
          },
        },
      });
      return res.data?.data?.content || [];
    },
  });

  return {
    series: data,
    isLoading,
  };
}
